import router from '@/router'
import store from '@/store'
import { getPageConfig } from "@/api/base";
import { getItem, setItem } from "@/utils/storage";
import {
    recordRoute,
    routesWhiteList
} from '@/config'

router.beforeResolve(async (to, from, next) => {
    if (routesWhiteList.indexOf(to.path) !== -1) {
        next();
    }
    else if (store.getters['user/accessToken']) {
        if (to.meta && to.meta.routeID) {
            const permissions = store.getters['user/permissions'];
            if (permissions.length > 0) {
                if (store.getters['user/permissions'].some(t => t == to.meta.routeID)) {
                    let pageConfig = {};
                    let itemName = `route-${to.meta.routeTitle}(${to.meta.routeID})`;
                    let pageConfigJson = getItem(itemName);
                    if (pageConfigJson == typeof undefined || pageConfigJson == null) {
                        const { data } = await getPageConfig({
                            routeID: to.meta.routeID,
                        });
                        pageConfig = data;
                        setItem(itemName, JSON.stringify(pageConfig));
                    } else {
                        pageConfig = JSON.parse(pageConfigJson);
                    }
                    to.meta["pageConfig"] = pageConfig;
                    handleKeepAlive(to);
                    next();
                }
                else {
                    next({ path: '/404' })
                }
                return;
            }
        }
        try {
            let accessRoutes = await store.dispatch('routes/setRoutes');
            let routeIDs = [];
            let loginRedirect = { name: store.getters['user/loginRedirect'] };
            let hasRoute = false;
            let isTargetHidden = false;
            let firstVisible = null; // 缓存的 loginRedirect 指向不存在或已隐藏的路由，回退到第一个不隐藏的路由
            accessRoutes.forEach((item) => {
                router.addRoute(item);
                if (item.children) {
                    item.children.forEach(c => {
                        if (c.name == loginRedirect.name) {
                            hasRoute = true;
                            isTargetHidden = !!(c.meta && c.meta.isHidden); //是否隐藏
                        }
                        if (!firstVisible && c.meta && !c.meta.isHidden) {
                            firstVisible = c; //
                        }
                        routeIDs.push(c.meta.routeID);
                    });
                }
            });
            if (!hasRoute || isTargetHidden) {
                // 缓存的 loginRedirect 指向不存在或已隐藏的路由，回退到第一个不隐藏的路由
                loginRedirect = firstVisible ? { name: firstVisible.name } : { path: '/404' };
            }
            await store.dispatch('user/setPermissions', routeIDs);
            // 刷新时校验当前 to.path 是否有效，若权限移除则回退
            let targetPath = to.path && to.path != '/' ? to.path : null;
            if (targetPath) {
                const resolved = router.resolve({ path: targetPath });
                const last = resolved && resolved.route && resolved.route.matched
                    ? resolved.route.matched[resolved.route.matched.length - 1] : null;
                if (!last || last.path === '*' || last.path === '/404') {
                    targetPath = null;
                }
            }
            next(targetPath ? { path: targetPath, query: to.query } : loginRedirect);
        } catch {
            await store.dispatch('user/resetAccessToken')
        }
    }
    else {
        next(recordRoute ? `/login?redirect=${to.path}` : '/login');
    }
    //document.title = getPageTitle(to.meta.title);
});

function handleKeepAlive(to) {
    if (to.matched && to.matched.length > 2) {
        for (let i = 0; i < to.matched.length; i++) {
            const element = to.matched[i];
            if (element.components.default.name === "EmptyLayout") {
                to.matched.splice(i, 1);
                i--;
            }
        }
    }
}

router.afterEach(() => {
    if (process.env.NODE_ENV !== 'dev') {
        let VUE_APP_VERSION = require('../../package.json').version;
        let vers = getItem("vueVersion");
        if (!vers || VUE_APP_VERSION != vers) {
            setItem("vueVersion", VUE_APP_VERSION);
            location.reload();
        }
    }
})